import colors, { palette } from './colors.mjs';

const keys = Object.keys;
const presetColorKeys = keys(colors);
const paletteColorKeys = keys(palette);
const presetGradientColorKeys = keys(palette.gradient);
const PRESET_COLOR_KEYS = new Set(Object.keys(colors));
function isPresetColor(color) {
  return PRESET_COLOR_KEYS.has(color);
}
const isPaletteKey = (color) => {
  return keys(palette).some((paletteKey) => paletteKey === color);
};
const isPresetGradientColor = (color) => {
  const gradientPalette = palette.gradient;
  return keys(gradientPalette).some((paletteKey) => paletteKey === color);
};

export { isPaletteKey, isPresetColor, isPresetGradientColor, paletteColorKeys, presetColorKeys, presetGradientColorKeys };
//# sourceMappingURL=presetColor.mjs.map
